import { ITotalAmount } from '../../../../types/reducers/checkoutInfo';
import { formatMoney, formatAuctionPoints } from '../../../../utils/string';

export const getTotalValue = ({ price, auctionPoints }: ITotalAmount): string => {
  return auctionPoints ? `${formatMoney(price)} и ${formatAuctionPoints(auctionPoints)}` : formatMoney(price);
};
